





































import Vue from "vue";
import {
  Komponent,
  komponentResource,
} from "@megarax/client/src/resources/plm/Komponent";
import { rodzajKomponentuResource } from "@megarax/client/src/resources/plm/RodzajKomponentu";
import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import { createComponent } from "@vue/composition-api";
import { required, maxLength } from "@/shared/validationRules";
import { formValidator } from "@/shared/formValidator";

const validationRules = {
  name: required,
  rodzaj: required,
};

export default createComponent({
  components: {
    DefaultRevisionForm,
  },
  props: {
    value: {
      type: Komponent,
      required: true,
    },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      komponentResource,
      rodzajKomponentuResource,
      validationRules,
    };
  },
});
